import { render, staticRenderFns } from "./TagFilters.vue?vue&type=template&id=5a33abfb&scoped=true&"
import script from "./TagFilters.vue?vue&type=script&lang=js&"
export * from "./TagFilters.vue?vue&type=script&lang=js&"
import style0 from "./TagFilters.vue?vue&type=style&index=0&id=5a33abfb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a33abfb",
  null
  
)

export default component.exports